const state = {
  noticeList: []
}

const getters = {

}

const mutations = {
}

const actions = {
  search ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/tp-catalog/search', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
